/* eslint-disable */
import createIcon from '../createIcon';

const IconPackage = createIcon({
  name: 'icon-package',
  content: '<title>ic_包裹</title><defs><rect id="icon-package-a" x="0" y="0" width="16" height="16"/></defs><g stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1191.000000, -5907.000000)"><g transform="translate(498.000000, 4920.000000)"><g transform="translate(111.000000, 987.000000)"><g transform="translate(582.000000, 0.000000)"><mask id="icon-package-b" fill="currentColor"><use xlink:href="#icon-package-a"/></mask><use fill="currentColor" opacity="0" xlink:href="#icon-package-a"/><path d="M16,1 L16,5 L15,5 L15,15 L1,15 L1,5 L0,5 L0,1 L16,1 Z M14,5 L2,5 L2,14 L14,14 L14,5 Z M10,6 L10,7 L6,7 L6,6 L10,6 Z M15,2 L1,2 L1,4 L15,4 L15,2 Z" fill="currentColor" fill-rule="nonzero" mask="url(#icon-package-b)"/></g></g></g></g></g>',
  width: 16,
  height: 16
}, 'Icon');
export default IconPackage;
